import { Link } from '@remix-run/react';
import logo from '~/assets/Logo.svg';
import { Links } from '../navbar/links';
import { Button } from '../ui/button';

import { format } from 'date-fns';
import instagram from '~/assets/icons/instagram.svg';
import tiktok from '~/assets/icons/tiktok.svg';
import x from '~/assets/icons/x.svg';
import youtube from '~/assets/icons/youtube.svg';
import useTranslation from '~/i18n/i18n';
import { useLogout } from '~/lib/hooks/use-logout';
import { useUser } from '~/lib/providers/user-provider';

type SocialLinkName = 'instagram' | 'tiktok' | 'x' | 'youtube';

type SocialLink = {
  name: SocialLinkName;
  href: string;
  icon: string;
};

export const links: SocialLink[] = [
  {
    name: 'instagram',
    href: 'https://www.instagram.com/scoreornot_official',
    icon: instagram,
  },
  {
    name: 'tiktok',
    href: 'https://www.tiktok.com/@scoreornot_official',
    icon: tiktok,
  },
  { name: 'x', href: 'https://x.com/scoreornotx', icon: x },
  {
    name: 'youtube',
    href: 'https://www.youtube.com/@scoreornot',
    icon: youtube,
  },
];

export const SocialLinks = () => {
  const { t } = useTranslation();
  return (
    <>
      {links.map((link) => (
        <Link
          key={link.href}
          to={link.href}
          target="_blank"
          rel="noreferrer noopener">
          <img
            src={link.icon}
            alt={t(`common.socials.${link.name}`)}
            className="dark:invert"
          />
        </Link>
      ))}
    </>
  );
};

export const LegalLinks = () => {
  const { t } = useTranslation();

  return (
    <>
      <Link to="/terms-conditions" target="_blank" rel="noreferrer noopener">
        {t('common.routes.termsConditions.title')}
      </Link>
      <span aria-hidden="true">|</span>
      <Link to="/privacy-policy" target="_blank" rel="noreferrer noopener">
        {t('common.routes.privacyPolicy.title')}
      </Link>
    </>
  );
};

export const Footer = () => {
  const { t } = useTranslation();
  const { user } = useUser();

  return (
    <footer className="flex w-full flex-col gap-8 pb-8">
      <div className="flex flex-col flex-wrap items-start justify-between md:flex-row md:items-center">
        <img
          src={logo}
          alt={t('common.appName')}
          className="mb-3 h-10 w-auto dark:invert"
        />
        <div className="flex flex-col flex-wrap items-start gap-x-10 gap-y-5 md:flex-row md:items-center">
          <Links />

          {user && <LogoutButton />}
        </div>
      </div>
      <div className="flex flex-col items-center justify-between gap-3 md:flex-row">
        <div className="flex flex-row items-center gap-2 text-sm opacity-50">
          <span>
            &copy; {format(new Date(), 'yyyy')} {t('common.appName')}
          </span>
          <LegalLinks />
        </div>
        <div className="flex flex-row items-center justify-center gap-4">
          <SocialLinks />
        </div>
      </div>
    </footer>
  );
};

const LogoutButton = () => {
  const { t } = useTranslation();
  const { logout, isLoading } = useLogout();

  return (
    <Button
      className="rounded-xl uppercase"
      variant="outline"
      disabled={isLoading}
      isLoading={isLoading}
      onClick={() => logout()}>
      {t('homePage.logout')}
    </Button>
  );
};
